import { render, staticRenderFns } from "./FAQNew.vue?vue&type=template&id=665b88a5&"
import script from "./FAQNew.vue?vue&type=script&lang=js&"
export * from "./FAQNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports